import styles from './FJPptToVideoStart.module.less';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJPptIcon from '../../../assets/svg/textToVideo/ppt.svg?react';
import FJPptSmallIcon from '../../../assets/svg/textToVideo/ppt-small.svg?react';
import PropTypes from 'prop-types';
import FJConfig from '../../../config/FJConfig.js';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload.jsx';
import { UPLOAD_FILE_TYPE_PPT } from '../../../config/dataConfig/FJGenerateData';
import UploadBorderHoverIcon from '../../../assets/svg/upload-border-hover.svg?react';
import UploadBorderIcon from '../../../assets/svg/upload-border.svg?react';
import { useState } from 'react';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil.js';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';

const FJPptToVideoStart = props => {
    const { onUploadPpt, onNext, pptFile, onRemovePpt } = props;
    const [isDraggingFile, setIsDraggingFile] = useState(false);

    const _onRemove = e => {
        e.stopPropagation();
        onRemovePpt();
    };
    const _dragCallback = type => {
        if (type === 'leave' || type === 'drop') {
            setIsDraggingFile(false);
        } else if (type === 'over') {
            setIsDraggingFile(true);
        }
    };
    const _renderPptFileInfo = () => {
        if (pptFile) {
            return (
                <div className={styles.upload_inner}>
                    <div className={styles.ppt_file_info}>
                        <FJPptSmallIcon />
                        <div className={styles.ppt_file_name}>{FJUtil.getEspText(pptFile.name, 14, 470).fileText}</div>
                    </div>
                    <div className={styles.remove_file} onClick={_onRemove}>
                        {FJLocalStore._('remove')}
                    </div>
                </div>
            );
        }
        return (
            <div className={styles.upload_inner}>
                <FJPptIcon />
                <div
                    className={styles.upload_text}
                    dangerouslySetInnerHTML={{
                        __html: FJLocalStore._('click-or-drag-to-upload'),
                    }}
                />
                <div className={styles.supports_text}>
                    {FJLocalStore._(
                        'please-upload-files-in-ppt-pptx-and-pdf-formats-the-file-should-be-up-to-50mb-and-50-pages',
                    )}
                </div>
            </div>
        );
    };
    return (
        <FJVerticalScroller
            className={styles.container}
            style={{ backgroundImage: `url(${FJConfig.resourceImagePath}ppt-to-video-bg.png)` }}
        >
            <div className={styles.title}>{FJLocalStore._('ai-ppt-to-video')}</div>
            <FJFileUpload
                disabled={!!pptFile}
                className={classNames(
                    styles.upload_box,
                    isDraggingFile && styles.dragging,
                    !!pptFile && styles.has_file,
                )}
                onUpload={onUploadPpt}
                accept={UPLOAD_FILE_TYPE_PPT}
                dragCallback={_dragCallback}
            >
                {_renderPptFileInfo()}
                <UploadBorderHoverIcon className={styles.upload_border_hover} />
                <UploadBorderIcon className={styles.upload_border} />
            </FJFileUpload>

            <FJButton text={FJLocalStore._('next')} className={styles.btn} type={'gradient'} onClick={onNext} />
        </FJVerticalScroller>
    );
};

FJPptToVideoStart.propTypes = {
    onUploadPpt: PropTypes.func,
    onNext: PropTypes.func,
    pptFile: PropTypes.object,
    onRemovePpt: PropTypes.func,
};

export default FJPptToVideoStart;
